import type { Action, ActionType } from './Action'

export enum ContainerAction {
  Drop = 'DROP',
  Pull = 'PULL',
  Empty = 'EMPTY',
}

const containerActionLabels = {
  [ContainerAction.Drop]: 'Déposer',
  [ContainerAction.Pull]: 'Retirer',
  [ContainerAction.Empty]: 'Bac vide',
}

export interface ContainerMove extends Action {
  type: ActionType.ContainerMove
  containerCode: string
  payload: {
    action: ContainerAction
    roomUuid: string
  }
}

export const getContainerActionLabel = (action: ContainerMove) => {
  return containerActionLabels[action.payload.action]
}
